import React, { useState } from "react";
import PieChart from "./PieChart";
import { Box, Grid, Typography } from "@mui/material";
import SimpleLineChart from "./SimpleLineChart";
import ParentSize from "@visx/responsive/lib/components/ParentSize";
import gender from "../../assets/sustainabilityReport/gender.svg";
import clock from "../../assets/sustainabilityReport/clock.svg";
import trip from "../../assets/sustainabilityReport/TRIP.svg";
import indirectEmp from "../../assets/sustainabilityReport/indirectEmp.svg";
import foreignEmp from "../../assets/sustainabilityReport/foreignEmp.svg";
import LineAreaGraph from "./LineAreaGraph";
import SelectFilter from "./SelectFilter";
import { transformSocialTrendData } from "../../utils/reportPage";

const SocialStatsCard = ({ icon, title, amount }) => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#FAE6EA",
        p: "20px",
        borderRadius: "12px",
        height: "100%",
      }}
    >
      <img
        src={icon}
        alt={title}
        height={24}
        width={24}
        style={{ marginBottom: "6px" }}
      />
      <h4 className="base-sector-card_title">{title}</h4>
      <Typography variant="h5" sx={{ fontSize: "18px" }}>
        {amount?.toLocaleString("en-IN")}
      </Typography>
    </Box>
  );
};

const SocialStats = ({ report }) => {
  const { socialKPI } = report;
  const last6yearsReportdata = [report, ...report?.last6YearsReports];
  console.log(last6yearsReportdata);

  const totalPopulation =
    socialKPI?.S1?.totalMen?.value +
    socialKPI?.S1?.totalWomen?.value +
    socialKPI?.S1?.totalNonBinary?.value;

  const cardData = [
    {
      id: 0,
      icon: gender,
      title: "Gender Ratio in Workforce",
      amount: (socialKPI?.S1?.totalMen?.value / totalPopulation)?.toFixed(2),
    },
    {
      id: 1,
      icon: trip,
      title: "TRIR (Incidents per 200,000 person hours)",
      amount: socialKPI?.S7?.trir?.value,
    },
    {
      id: 2,
      icon: indirectEmp,
      title: "Proportion of Indirect employees (%)",
      amount: socialKPI?.S3?.indirectEmployees?.value,
    },
    {
      id: 3,
      icon: foreignEmp,
      title: "Proportion of foreign employees (%)",
      amount: socialKPI?.S2?.foreignEmployees?.value,
    },
    {
      id: 4,
      icon: clock,
      title: "Hours of training provided to employees (hours/employee)",
      amount: socialKPI?.S5?.trainingHours?.value,
    },
  ];

  const data = [
    { label: "SCOPE 1", value: 50 },
    { label: "SCOPE 2", value: 30 },
    { label: "SCOPE 3", value: 30 },
  ];

  const trendData = [
    { quarter: "Q1 2023", value: 10 },
    { quarter: "Q2 2023", value: 20 },
    { quarter: "Q3 2023", value: 15 },
    { quarter: "Q4 2023", value: 25 },
    { quarter: "Q1 2024", value: 30 },
    { quarter: "Q2 2024", value: 25 },
    { quarter: "Q3 2024", value: 35 },
    { quarter: "Q4 2024", value: 45 },
    { quarter: "Q1 2025", value: 50 },
    { quarter: "Q2 2025", value: 40 },
    { quarter: "Q3 2025", value: 45 },
  ];

  const genderPieChart = [
    { label: "Men", value: socialKPI?.S1?.totalMen?.value },
    { label: "Women", value: socialKPI?.S1?.totalWomen?.value },
    { label: "Non-Binary", value: socialKPI?.S1?.totalNonBinary?.value },
  ];

  // Social KPIs trends PENDING
  const socialKpiOptions = [
    {
      name: "Proportion of indirect employees",
      value: "indirectEmployees",
      unit: "Percentage(%)",
    },
    {
      name: "Proportion of male employees",
      value: "totalMen",
      unit: "Percentage(%)",
    },
    {
      name: "TRIR",
      value: "trir",
      unit: "Incidents per 200,000 man-hours worked",
    },
  ];

  const [trendFilter, setTrendFilter] = useState(socialKpiOptions[0]?.value);

  const handleTrendChange = (e) => {
    setTrendFilter(e.target.value);
  };

  const formattedSocialTrendsData = transformSocialTrendData(
    last6yearsReportdata?.slice(-6),
    trendFilter
  );
  console.log(formattedSocialTrendsData);

  return (
    <>
      <h1 className="sustainability-section_heading">Social Index</h1>

      {/* PINK DIVS */}
      <Grid container spacing={2.5} sx={{ mb: "20px" }}>
        {cardData.map((item) => (
          <Grid key={item.id} item xs={2.4}>
            <SocialStatsCard {...item} />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2.5} sx={{ mb: "60px" }}>
        <Grid item xs={8.4}>
          <Box
            sx={{
              width: "100%",
              height: "20rem",
              borderRadius: "12px",
              p: 2,
              backgroundColor: "#FFF",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              <h2>
                Social KPIs trends
                <span className="sustain-subheading-h2"> (%)</span>
              </h2>
              <SelectFilter
                onChange={handleTrendChange}
                options={socialKpiOptions}
                value={trendFilter}
                placeholder={"Select Trend"}
              />
            </div>
            <div style={{ height: "260px" }}>
              <ParentSize>
                {({ width, height }) => (
                  <LineAreaGraph
                    data={formattedSocialTrendsData}
                    height={height}
                    width={width}
                    gradientFrom="#FF8FA5"
                    gradientTo="#fff"
                    lineColor={"#FF8FA5"}
                    leftLabel={
                      socialKpiOptions?.find(
                        (item) => item?.value === trendFilter
                      )?.unit
                    }
                    tooltipLabel={
                      socialKpiOptions?.find(
                        (item) => item?.value === trendFilter
                      )?.name
                    }
                  />
                )}
              </ParentSize>
            </div>
          </Box>
        </Grid>
        <Grid item xs={3.6}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "12px",
              p: 2,
              backgroundColor: "#FFF",
            }}
          >
            <h2>
              Gender Diversity
              <span className="sustain-subheading-h2"> (%)</span>
            </h2>
            <div style={{ height: "220px" }}>
              <ParentSize>
                {({ width, height }) => (
                  <PieChart
                    colors={["#FAE6EA", "#FF8FA5", "#FFF5F7"]}
                    data={genderPieChart}
                    width={width}
                    height={height}
                  />
                )}
              </ParentSize>
            </div>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SocialStats;
